export const ConfidenceScore = 0.4;
